package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.launchBusinessDetail
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.splash
import org.jetbrains.compose.resources.painterResource

@Composable
fun LatestBusinessView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        uiState.businessUiState.getLatestBusiness().let {
            if (it.isEmpty()) {
                Column(
                    Modifier.fillMaxSize().padding(8.dp),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    CommonImage(painterResource(splash), Modifier.width(150.dp).height(150.dp))
                    Spacer(Modifier.height(8.dp))
                    Text14RegularBB(text = "No Listings Available Yet", color = black)
                    Spacer(Modifier.height(8.dp))
                    Text14RegularB(
                        text = "Businesses are actively registering, and listings will be live soon. Check back shortly to discover new and exciting businesses!",
                        color = black
                    )
                }
            } else {
                LazyColumn(modifier = Modifier.fillMaxWidth().padding(8.dp)) {
                    items(it, key = { it.getId() }) { businessOld ->
                        val business =
                            getBusinessUiState().isBusinessFetched.value[businessOld.getId()]
                                ?: businessOld
                        if (!business.isBusinessDeleted()) {
                            BusinessCardFull(uiState, onTriggerEvent, business) {
                                launchBusinessDetail(business)
                            }
                            Spacer(Modifier.height(8.dp))
                        }
                    }
                }
            }
        }
    }
}